var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C11.2667 24 10.6387 23.7387 10.116 23.216C9.59334 22.6933 9.33245 22.0658 9.33334 21.3333V5.33333C9.33334 4.6 9.59467 3.972 10.1173 3.44933C10.64 2.92667 11.2676 2.66578 12 2.66667H24C24.7333 2.66667 25.3613 2.928 25.884 3.45067C26.4067 3.97333 26.6676 4.60089 26.6667 5.33333V21.3333C26.6667 22.0667 26.4053 22.6947 25.8827 23.2173C25.36 23.74 24.7324 24.0009 24 24H12ZM12 21.3333H24V5.33333H12V21.3333ZM6.66667 29.3333C5.93334 29.3333 5.30534 29.072 4.78267 28.5493C4.26 28.0267 3.99911 27.3991 4 26.6667V9.33333C4 8.95555 4.128 8.63867 4.384 8.38267C4.64 8.12667 4.95645 7.99911 5.33334 8C5.71111 8 6.028 8.128 6.284 8.384C6.54 8.64 6.66756 8.95644 6.66667 9.33333V26.6667H20C20.3778 26.6667 20.6947 26.7947 20.9507 27.0507C21.2067 27.3067 21.3342 27.6231 21.3333 28C21.3333 28.3778 21.2053 28.6947 20.9493 28.9507C20.6933 29.2067 20.3769 29.3342 20 29.3333H6.66667Z",
    fill: "#215C75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content-copy.7071a23a9b026e0fbd8c0b210072fb58.svg";
export { ForwardRef as ReactComponent };